<script setup>
import InputError from "@/Components/InputError.vue";
import PrimaryBtn from "@/Components/PrimaryBtn.vue";
import InputField from "@/Components/InputField.vue";
import InputLabel from "@/Components/InputLabel.vue";

import { defineProps, ref, computed, watch, inject } from "vue";
import Swal from "sweetalert2";
import { useForm } from "@inertiajs/vue3";
const route = inject('route');
const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },

  repository: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["update:isOpen"]);

const form = useForm({
  id: null,

  file_path: null,
});

const handleFileUpload = (event) => {
  form.file_path = event.target.files[0] || "";
};
const fileInput = ref(null);

watch(
  () => props.repository,
  (newRepo) => {
    if (newRepo) {
      form.id = newRepo.id;
      form.iddok = newRepo.iddok;
      form.file_path = newRepo.file_path;
    }
  },
  { immediate: true, deep: true }
);
// Close modal
const closeModal = () => {
  emit("update:isOpen", false); // Emit event untuk menutup modal
};

// Handle click outside modal
const handleClickOutside = (event) => {
  if (event.target === event.currentTarget) {
    closeModal();
  }
};

const submit = () => {
  form.post(route("pelaporan.updatefile", form.iddok), {
    onSuccess: () => {
      form.reset();
      closeModal();
    },
  });
};
</script>
<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-start justify-center pt-10 bg-black bg-opacity-50"
    @click="handleClickOutside"
  >
    <div
      class="relative w-full h-auto max-h-[90vh] p-4 overflow-y-auto bg-white rounded-lg sm:w-1/2 sm:p-6"
    >
      <div class="flex items-center justify-between mb-6">
        <h2 class="text-xl font-bold">{{ title }}</h2>
        <button
          type="button"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="closeModal"
          class="text-gray-500 transition duration-150 hover:text-gray-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <form class="space-y-6" @submit.prevent="submit">
        <div class="mt-4">
          <InputLabel for="File" value="File" class="mb-2" />
          <input type="file" ref="fileInput" @change="handleFileUpload" />
          <progress
            v-if="form.progress"
            :value="form.progress.percentage"
            max="100"
          >
            {{ form.progress.percentage }}%
          </progress>
          <InputError class="mt-2" :message="form.errors.file_path" />
        </div>
        <div class="mt-4">
          <PrimaryBtn :disabled="form.processing">
            <i class="fa-solid fa-floppy-disk"></i> Simpan
          </PrimaryBtn>
        </div>
      </form>
    </div>
  </div>
</template>
